export class PharmacyClosingStock {
    productname: string;
    storeName: string;
    storeId: number;
    batchNumber: string;
    availableQuantity: number;
    stockDate: Date;
    type: string;
    pharmacyProductId: number;
    purchaseRate: number;
    taxAmount: number;
    totalAmount: number;
    netAmount: number;
}